import { findByCubeId } from './baseQuery';
import { __set__ } from './db';

export function add(cubeId: CubeId, cube: CubeNode): void {
    // let parent: CubeNode = findByCubeId(params.parentId);

    __set__(cubeId, cube);
    // parent.add(params.beAddCube, params.index, params.cb);
}
